import { render, staticRenderFns } from "./KEditable.vue?vue&type=template&id=cb9c20b4&scoped=true&"
import script from "./KEditable.vue?vue&type=script&lang=js&"
export * from "./KEditable.vue?vue&type=script&lang=js&"
import style0 from "./KEditable.vue?vue&type=style&index=0&id=cb9c20b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9c20b4",
  null
  
)

export default component.exports